<!--
  @Description 流程打回弹窗——暂时弃用
  @Date 2022-03-22
  @Author liushuo
-->
<template>
  <vxe-modal
    v-model="isShow"
    size="mini"
    width="80%"
    height="90%"
    @show="showWindows"
    @close="closeWindows"
    show-zoom
  >
    <!-- 标题 -->
    <template #title>
      <span>流程打回</span>
      <!-- 模块名称 -->
      <!-- <span style="margin-left: 10px">{{ `[${form.groupName}]` }}</span> -->
      <span style="margin-left: 5px">{{ form.vuePath }}</span>
    </template>

    <div class="modal-dv">
      <!-- 编辑区域 -->
      <div class="edit-dv">
        <el-form
          :model="form"
          ref="FormRef"
          :validate-on-rule-change="false"
          :rules="rules"
          size="small"
        >
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="问题号" prop="groupName">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="form.groupName"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  :disabled="true"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="下发版本" prop="productionType">
                <el-select
                  clearable
                  filterable
                  v-model="form.productionType"
                  size="small"
                  :disabled="true"
                  :placeholder="placeholderConfig.relation"
                >
                  <el-option
                    v-for="i of selectOptions.productionType"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="下发日期" prop="productionVersion">
                <el-date-picker
                  v-model="form.spDate"
                  v-date
                  type="date"
                  :placeholder="placeholderConfig.relation"
                  value-format="yyyy-MM-dd"
                  :disabled="true"
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <div class="error-icon">
                    <el-tooltip
                      :content="slot.error"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-warning"></i>
                    </el-tooltip>
                  </div>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="打回日期" prop="yingxiangbanben">
                <el-date-picker
                  v-model="form.spDate"
                  v-date
                  type="date"
                  :placeholder="placeholderConfig.input"
                  value-format="yyyy-MM-dd"
                  :disabled="!this.$parent.Authority.edit"
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <div class="error-icon">
                    <el-tooltip
                      :content="slot.error"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-warning"></i>
                    </el-tooltip>
                  </div>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目经理" prop="businessTester">
                <el-select
                  clearable
                  filterable
                  v-model="form.frontEngineer"
                  size="small"
                  :disabled="!this.$parent.Authority.edit"
                  :placeholder="placeholderConfig.relation"
                >
                  <el-option
                    v-for="i of selectOptions.persons"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="前端解决人" prop="frontEngineer">
                <el-select
                  clearable
                  filterable
                  v-model="form.frontEngineer"
                  size="small"
                  :disabled="!this.$parent.Authority.edit"
                  :placeholder="placeholderConfig.relation"
                >
                  <el-option
                    v-for="i of selectOptions.persons"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6"
              ><el-form-item label="后端解决人" prop="backEngineer">
                <el-select
                  clearable
                  filterable
                  v-model="form.frontEngineer"
                  size="small"
                  :disabled="!this.$parent.Authority.edit"
                  :placeholder="placeholderConfig.relation"
                >
                  <el-option
                    v-for="i of selectOptions.persons"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6"
              ><el-form-item label="技术测试" prop="techTester">
                <el-select
                  clearable
                  filterable
                  v-model="form.frontEngineer"
                  size="small"
                  :disabled="!this.$parent.Authority.edit"
                  :placeholder="placeholderConfig.relation"
                >
                  <el-option
                    v-for="i of selectOptions.persons"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务测试" prop="businessTester">
                <el-select
                  clearable
                  filterable
                  v-model="form.frontEngineer"
                  size="small"
                  :disabled="!this.$parent.Authority.edit"
                  :placeholder="placeholderConfig.relation"
                >
                  <el-option
                    v-for="i of selectOptions.persons"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="打回原因" prop="content">
                <el-input
                  type="textarea"
                  :rows="15"
                  v-model="form.content"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  :disabled="!this.$parent.Authority.edit"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="button-dv">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="cancel">返回</el-button>
      </div>
    </div>
  </vxe-modal>
</template>

<script>
import { MessageBox } from 'element-ui'

export default {
  name: 'FlowCancelModal',
  components: {},
  props: {
    parentObj: Object,
    // 当前数据行id
    id: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      form: {},
      rules: {},
      // 下拉框列表
      combobox: {
        // 说明类型
        result: [],
      },
      selectOptions: {
        productionType: [],
        productionVersion: [],
        // 影响版本
        yingxiangbanben: [
          {
            name: '/',
            value: '/',
          },
        ],
        // 严重程度
        yanzhongchengdu: [
          {
            name: '轻微',
            value: '轻微',
          },
          {
            name: '一般',
            value: '一般',
          },
          {
            name: '严重',
            value: '严重',
          },
        ],
        // 优先级
        youxianji: [
          {
            name: 'I',
            value: 'I',
          },
          {
            name: 'II',
            value: 'II',
          },
          {
            name: 'III',
            value: 'III',
          },
        ],
        BugType: [
          {
            name: '代码错误',
            value: '代码错误',
          },
          {
            name: '下发相关',
            value: '下发相关',
          },
          {
            name: '数据处理',
            value: '数据处理',
          },
          {
            name: '其他',
            value: '其他',
          },
        ],
        persons: [],
        frontEngineer: [],
        backEngineer: [],
        techTester: [],
        businessTester: [],
      },
    }
  },
  methods: {
    // 监听模态框开启
    async showWindows() {
      this.setFormRules()
      // 获取人员下拉框
      await this.getPerson()
      await this.getProduct()
    },
    // 设置表单校验规则
    setFormRules() {
      this.rules = {
        result: [
          // { required: true, message: '请选择问题结论', trigger: 'change' },
        ],
      }
    },
    // 获取人员数据
    async getPerson() {
      this.selectOptions.frontEngineer = []
      this.selectOptions.backEngineer = []
      this.selectOptions.techTester = []
      this.selectOptions.businessTester = []
      this.selectOptions.persons = []

      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999,
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data.rows) {
        // let cache = {
        //   name: item.name,
        //   value: item.id + '@' + item.num + '@' + item.name + '@' + item.post
        // }
        const temp = {
          name: item.name,
          value: item.name,
        }
        // TODO 前后端、技术测试、业务测试过滤
        this.selectOptions.frontEngineer.push(temp)
        this.selectOptions.backEngineer.push(temp)
        this.selectOptions.techTester.push(temp)
        this.selectOptions.businessTester.push(temp)
        this.selectOptions.persons.push(temp)
      }
    },
    // 获取产品类型、产品版本下拉框
    async getProduct() {
      this.selectOptions.productionType = []
      const { data: selectRes } = await this.$http.get(
        '/Common/BMenuGroup/select-item'
      )
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'ProductionType':
              this.selectOptions.productionType.push(item)
              break
          }
        }
      }
    },
    // 当类型改变
    async changeType(type, isInit = false) {
      this.selectOptions.productionVersion = []
      if (!type || type === '') {
        this.form.productionVersion = ''
        return
      }
      const { data: res } = await this.$http.post(
        `/Common/ProductVersionSet/list?sqlTitle=${type}`
      )
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data) {
        this.selectOptions.productionVersion.push({
          name: item.productionVersion,
          value: item.productionVersion,
        })
      }
      const option = this.selectOptions.productionVersion.filter((item) => {
        return item.value === this.form.productionVersion
      })
      if (!isInit && option.length <= 0) {
        this.form.productionVersion = ''
      }
    },
    // 监听模态框关闭
    closeWindows() {
      this.$refs['FormRef'].resetFields()
    },
    // 保存
    async save() {
      this.$message.warning('保存')
      // TODO 调用保存接口
      // if (!this.$parent.Authority.edit) {
      //   return false
      // }

      // const isCanSave = await this.validForm()
      // if (!isCanSave) return

      // // TODO 调用保存接口
      // this.closeModal()
    },
    // 校验表单
    async validForm() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        (res) => {
          flag = res
        },
        (err) => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('请正确填写信息')
      }
      return flag
    },
    // TODO 删除
    deleteItem() {
      if (!this.$parent.specialAuthority.super) {
        return false
      }
      MessageBox.confirm('确认删除吗？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpDelItem()
        })
        .catch(() => {
          // do something
        })
    },
    // 发起删除请求
    async httpDelItem() {
      if (this.id < 0) {
        this.$message.error('未保存的数据不可删除')
        return
      }
      const { data: res } = await this.$http.delete('/Common/YKCase', {
        data: {
          id: this.id,
        },
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      // 重新刷新主页面（因为有删除，所以需要全量刷新）
      this.parentObj.getList()
      this.closeModal()
    },
    openModal() {
      this.isShow = true
    },
    closeModal() {
      this.isShow = false
    },
    /**
     * @description 格式化说明
     * @param {String} comment 说明内容
     * @returns Array[{type, date, user, instruction}]
     */
    formatContentWrap(comment) {
      let res = []
      if (comment == null || comment.trim() === '') {
        return res
      }
      // 1.按句分割
      let sentence = comment.split('!#!')
      sentence.forEach((v) => {
        // 2.按字段分割，[0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:问题说明id
        const word = v.split('!&!')
        const temp = {
          type: word[0] || '无',
          date: word[1] || '无',
          user: word[2] || '无',
          instruction: word[3] || '无',
        }
        if (
          this.$store.state?.systemSetting?.explainSort &&
          this.$store.state.systemSetting.explainSort === 'asc'
        ) {
          res.unshift(temp)
        } else {
          res.push(temp)
        }
      })
      return res
    },
    // 返回
    cancel() {
      this.closeModal()
      // TODO 重置表单数据
    },
  },
  computed: {
    tableHeight() {
      if (this.approveDisplay) {
        return '225px'
      } else {
        return '100px'
      }
    },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    },
  },
}
</script>

<style lang="less" scoped>
@history-dv-height: 200px;
@all-dv-width: 98%;
// 编辑说明和历史说明之间的间隔
@dv-margin: 10px;
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
// 整体内边距
@all-dv-padding: 10px;
@button-dv-height: 60px;

.modal-dv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 @all-dv-padding;
  position: relative;
}

.edit-dv {
  width: 100%;
  margin: 0 auto;
  // height: calc(
  //   // dv-margin: 需要乘的数值 = 整体区块数量 + 1（如加了一个 gap-dv，则需要 + 1）
  //     100% - @history-dv-height - @dv-margin*4 - @gap-height - @gap-margin
  // );
  height: calc(100% - @button-dv-height);
  overflow-y: scroll;
  overflow-x: hidden;
}

.button-dv {
  width: calc(100% - @all-dv-padding * 2);
  height: @button-dv-height;
  background-color: #f8f8f8;
  border-radius: 20px;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
}

.edit-dv::-webkit-scrollbar {
  display: none;
}

.btn-dv-prohibit {
  transition: none !important;
  opacity: 0.5 !important;
}
.btn-dv-prohibit:hover {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}

.el-row {
  margin-bottom: 12px !important;
}

/deep/ .el-button {
  width: 120px;
}
</style>
